angular.module('signalview.chartTemplates').run([
    'chartTemplates',
    'Chart',
    'blockService',
    function (chartTemplates, Chart, blockService) {
        function createChart(filters) {
            const chart = Chart.create()
                .name('Total Network I/O')
                .type('column')
                .forcedResolution(30000)
                .colorByMetric(true)
                .yAxis(0, { label: 'transmitted - BLUE' })
                .yAxis(1, { label: 'received - RED' });

            const inputPlot = chart
                .plot()
                .metric('if_octets.tx')
                .color('#0077c2')
                .yAxis(0)
                .propertyFilter('plugin_instance', 'eth*')
                .propertyFilter('plugin', 'interface')
                .propertyFilters(filters)
                .addManipulation(blockService.sum.asAggregation());

            // Output plot is just a clone of the previous with some modifications
            inputPlot.cloneTo(chart).metric('if_octets.rx').color('#b04600').yAxis(1);

            return chart;
        }

        chartTemplates.register('collectdHostsTotalNetworkIO', createChart);
    },
]);
